{
  "EMOJI": {
    "PLACEHOLDER": "Pretraži emojije",
    "NOT_FOUND": "Nijedan emoji ne odgovara pretraživanju",
    "REMOVE": "Izbaci"
  }
}
